class Randomizer {
    constructor(low = 0, high = low) {
      this.low = low;
      this.high = high;

      this.reset();
    }

    reset() {
        this.remaining = [];

        for (var i = this.low; i <= this.high; i++) {
            this.remaining.push(i);
        }
    }

    get() {
        if (!this.remaining.length) {
            this.reset();
        }

        var index = Math.floor(Math.random() * this.remaining.length);
        var val = this.remaining[index];

        this.remaining.splice(index, 1);
        return val;
    }
}

function InvervalTimer(callback, interval) {
    var timerId, startTime, remaining = 0;
    var state = 0; //  0 = idle, 1 = running, 2 = paused, 3= resumed

    this.pause = function () {
        if (state != 1) return;

        remaining = interval - (new Date() - startTime);
        window.clearInterval(timerId);
        state = 2;
    };

    this.resume = function () {
        if (state != 2) return;

        state = 3;
        window.setTimeout(this.timeoutCallback, remaining);
    };

    this.timeoutCallback = function () {
        if (state != 3) return;

        callback();

        startTime = new Date();
        timerId = window.setInterval(callback, interval);
        state = 1;
    };

    startTime = new Date();
    timerId = window.setInterval(callback, interval);
    state = 1;
}

function navigation(questions){
    const containerCount = questions.find('.box-campaign-questions-container');
    let navLinks = '';

    containerCount.each(function(i){
        navLinks += `<a href="#" class="${(i === 0) ? 'active' : ''}"></a>`;
    });

    const nav = questions.append(`<nav class="box-campaign-questions-nav" style="${ containerCount.length <= 1 ? 'display:none' : '' }">${navLinks}</nav>`);

    nav.find('.box-campaign-questions-nav').on('click', 'a', function(){
        var index = $(this).index();

        questions.find('.box-campaign-questions-nav a').removeClass('active');

        $(this).addClass('active');

        questions.find('.box-campaign-questions-container').removeClass('active');
        questions.find('.box-campaign-questions-container').eq(index).addClass('active');

        return false;
    }).find(':first-child').trigger('click')
}

function autoplay(questions){
    const questionCount =  questions.find('.active .box-campaign-questions-item').length - 1;
    const random = new Randomizer(0, questionCount);

    const timer = new InvervalTimer(function () {
        var index = random.get();
        questions.find('.active .box-campaign-questions-item').eq(index).trigger('click');
    }, 5000);

    questions.on('mouseenter', function(){
        timer.pause();
    }).on('mouseleave', function(){
        timer.resume();
    });
}

export function init(scope){
    const isCampaign = $('.is-campaign');

    if(!isCampaign.length) {
        return;
    }

    // Scroll button
    /*const link = isCampaign.find('hr:eq(0)').before('<div><a href="#" class="btn btn-scroll-down" /></div>')
    isCampaign.find('.btn-scroll-down').on('click', function(){
        $('html, body').animate({ scrollTop: $(window).height() / 2 }, 600);
        return false;
    });*/


    isCampaign.find('.box-campaign-questions').each(function(){


        const campaignQuestions = $(this);

        campaignQuestions.find('.box-campaign-questions-item:first-child').addClass('active');
        campaignQuestions.find('.box-campaign-questions-item').on('click', function(e){
            e.preventDefault()

            campaignQuestions.find('.active .box-campaign-questions-item').removeClass('active');

            $(this).addClass('active');

        });

        campaignQuestions.find('.box-campaign-questions-item .text-limit').on('click', function(){
            console.log('df')
        })

        navigation(campaignQuestions);

        autoplay(campaignQuestions);
    });
}